<template>
  <button
    type="button"
    :class="[
      ...colorVariant,
      ...sizeVariant,
      ...disabledVariant,
      'rounded focus:outline-none inline-flex items-center justify-center',
    ]"
    v-on="$listeners"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<script>
  export default {
    name: 'BaseButton',

    props: {
      variant: {
        type: String,
        default: 'blue',
        validator: (v) => {
          return ['none', 'blue', 'blue-transparent'].indexOf(v) !== -1;
        },
      },
      size: {
        type: String,
        default: 'sm',
        validator: (v) => {
          return ['none', 'xs', 'sm', 'md'].indexOf(v) !== -1;
        },
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      colorVariant() {
        const variants = {
          none: [],
          blue: [
            'text-white',
            'bg-trueBlue',
            'hover:bg-absoluteZero',
            'active:bg-midnightBlue',
            'focus:shadow-outline',
          ],
          'blue-transparent': [
            'bg-transparent',
            'text-absoluteZero',
            'border',
            'border-paleCornflowerBlue',
            'hover:bg-aliceBlue',
            'hover:border-absoluteZero',
            'active:text-black',
            'focus:shadow-outline',
          ],
        };

        if (this.disabled) {
          return [];
        }

        return variants[this.variant];
      },
      sizeVariant() {
        const sizes = {
          none: [],
          xs: ['text-xs', 'py-1', 'px-3'],
          sm: ['text-sm', 'py-2', 'px-4'],
          md: ['text-base', 'py-3', 'px-6'],
        };

        return sizes[this.size];
      },
      disabledVariant() {
        if (
          this.disabled &&
          ['blue-transparent'].indexOf(this.variant) !== -1
        ) {
          return [
            'text-sonicSilver',
            'border',
            'border-gainsboro',
            'cursor-not-allowed',
          ];
        }

        if (this.disabled) {
          return ['text-white', 'bg-metallicSilver', 'cursor-not-allowed'];
        }
        return [];
      },
    },
  };
</script>
